module.exports = __webpack_public_path__ + "media/images/landing_page/viesi-265ac37378b51bdf9febde61948ad7e5.webp";